import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  onClose: () => void
  employee: Employee
}

const SetWelcomeSpaceAccessModal = ({ onClose, employee }: Props) => {
  const { running, performAction: onSubmit } = useAsyncAction(async () => {
    const value = await employee.setRegularAccessStartDate()
    employee.set(value)
    onClose()
  })

  return (
    <Modal
      title={i18n.t('employees.welcome_space.modal.title')}
      description={i18n.t('employees.welcome_space.modal.description')}
      illustration="window-user"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary" disabled={running}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('employees.welcome_space.modal.cta')}
          </Button>
        </>
      }
    />
  )
}

export default observer(SetWelcomeSpaceAccessModal)
